/* eslint-disable prettier/prettier */
import React, { useRef, useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import {
  format,
  parseISO,
  differenceInYears,
  isAfter,
  addYears,
} from 'date-fns';

import { Row, Col, Button, ButtonGroup } from 'react-bootstrap';
import { FaTrashAlt } from 'react-icons/fa';

import api from '../../services/api';
import apiCep from '../../services/apiCep';

import getValidationErrors from '../../utils/getValidationErrors';
import {
  formataCPF,
  formataCep,
  formataTelefone,
  formataIdade,
  replaceCaracteres,
  validarCNPJ,
  validarCPF,
  htmlDecode,
  replaceHTMLparaWhatsapp,
  TIPO_USUARIO,
} from '../../utils/funcoes';

import {
  optionsEscolaridade,
  optionsEstCivil,
  optionsOrigemCadastro,
  optionsSexo,
  optionsUF,
} from '../../utils/options';

import { useToast } from '../../hooks/toast';
import { useClinica } from '../../hooks/clinica';

import { ContainerDados } from './styles';

import Input from '../Input';
import Avatar from '../Avatar';
import InputMask from '../InputMask';
import SelectSync from '../SelectSync';
import Loading from '../Loading';
import Modal from '../Modal';
import { IPacienteFormatado } from '../PacienteCabecalho';
import getResponseErrors from '../../utils/getResponseErrors';
import { useAuth } from '../../hooks/auth';

export interface ICartao {
  PlaCodigo: number;
  Status: string;
  Parcelas: number;
  PlaContratoAssinado?: boolean;
}
interface IPaciente {
  PacCodigo: number;
  PacChave: string;
  PacNome: string;
  PacNomeSocial: string;
  PacPessoaFisica: boolean;
  pessoaFisicaForm?: string;
  PacDataNasc: Date;
  PacCPF: string;
  PacRG: string;
  PacCNPJ: string;
  PacIE: string;
  PacContato: string;
  PacTelefone: string;
  PacCelular: string;
  PacEmail: string;
  PacEndereco: string;
  PacNumero: string;
  PacBairro: string;
  PacCidade: string;
  PacCidadeCodigo: string;
  PacCEP: string;
  PacComplemento: string;
  PacUF: string;
  PacDataCadastro?: Date;
  PacSexo: string;
  PacProfissao: string;
  PacEstCivil: string;
  PacEscolaridade: string;
  PacResponsavel: string;
  PacResponsavelCPF: string;
  PacResponsavelRG: string;
  PacAtivo?: boolean;
  avatar_url?: string;
  PacRestrito?: boolean;
  PacFoto?: string;
  PacSenha?: string;
  PacClinica?: number;
  possuiCartao: boolean;
  cartao?: ICartao[];
  textoMensagem: string;
  textoDigisacFormatado: string;
}

interface IPacienteMenu {
  PacNome: string;
  PacNomeSocial: string;
  PacCodigo: number;
  avatar_url?: string;
  possuiCartao: boolean;
  cartao?: ICartao[];
}

type PacienteProps = {
  pacCodigo?: number;
  exibeMenu?: boolean;
  handleRetornaDados?(dadosPaciente: IPacienteFormatado): void;
  handleDadosMenu?(dadosPaciente: IPacienteMenu): void;
};

const PacienteCadastro: React.FC<PacienteProps> = ({
  pacCodigo,
  exibeMenu = false,
  handleRetornaDados,
  handleDadosMenu,
}) => {
  const { addToast } = useToast();
  const { user } = useAuth();
  const history = useHistory();
  const [paciente, setPaciente] = useState<IPaciente | undefined>(undefined);
  const formRefPaciente = useRef<FormHandles>(null);
  const [loading, setLoading] = useState(false);
  const [showModalExcluir, setShowModalExcluir] = useState(false);
  const [showModalDadosAcesso, setShowModalDadosAcesso] = useState(false);
  const [pessoaFisica, setPessoaFisica] = useState(true);
  const [loadingCEP, setLoadingCEP] = useState(false);
  const [idade, setIdade] = useState('');
  const [limitDate, setLimitDate] = useState<{ max: string; min: string }>();

  const { imagensClinica } = useClinica();
  const cliSaoPaulo = !!imagensClinica.find(img => img.nome === 'saopaulo');

  useEffect(() => {
    if (!cliSaoPaulo) {
      formRefPaciente.current?.setData({
        ...formRefPaciente.current?.getData(),
        PacTag: 'clinica',
      });
    }
  }, [cliSaoPaulo])

  useEffect(() => {
    async function loadDados(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get<IPaciente>(
          `/pacientes/pacientemaiscartao/${pacCodigo}/`,
        );
        setPessoaFisica(response.data.PacPessoaFisica);
        setPaciente(response.data);

        const dataNasc =
          response.data.PacPessoaFisica &&
            response.data.PacDataNasc.toString().length > 9
            ? parseISO(response.data.PacDataNasc.toString())
            : new Date();
        setIdade(formataIdade(dataNasc, false));
        formRefPaciente.current?.setData({
          ...formRefPaciente.current?.getData(),
          ...response.data,
          PacDataNasc: format(dataNasc, 'yyyy-MM-dd'),
          PacTelefone: formataTelefone(response.data.PacTelefone),
          PacCelular: formataTelefone(response.data.PacCelular),
          PacCPF: formataCPF(response.data.PacCPF),
          PacCNPJ: formataCPF(response.data.PacCNPJ),
          PacResponsavelCPF: formataCPF(response.data.PacResponsavelCPF),
          PacCEP: formataCep(response.data.PacCEP),
        });
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível buscar dados',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    }
    if (pacCodigo && pacCodigo > 0) {
      loadDados();
    }
  }, [addToast, pacCodigo, handleDadosMenu]);

  useEffect(() => {
    if (handleDadosMenu && paciente) {
      handleDadosMenu({
        PacNome: paciente.PacNome,
        PacNomeSocial: paciente.PacNomeSocial,
        PacCodigo: paciente.PacCodigo,
        avatar_url: paciente.avatar_url,
        possuiCartao: paciente.possuiCartao,
        cartao: paciente.cartao,
      });
    }
  }, [paciente, handleDadosMenu]);

  useEffect(() => {
    setLimitDate({
      min: format(addYears(new Date(), -150), 'yyyy-MM-dd'),
      max: format(new Date(), 'yyyy-MM-dd'),
    });
  }, []);

  const handleBuscaCepApi = useCallback(async () => {
    if (formRefPaciente && formRefPaciente.current) {
      const cep = replaceCaracteres(
        String(formRefPaciente.current.getFieldValue('PacCEP')),
      );

      if (cep && cep.length !== 8) {
        return;
      }

      setLoadingCEP(true);
      try {
        const response = await apiCep.get(`/${cep}/json`);
        formRefPaciente.current?.setData({
          ...formRefPaciente.current?.getData(),
          PacBairro: response.data.bairro,
          PacCidade: response.data.localidade,
          PacCidadeCodigo: response.data.ibge,
          PacEndereco: response.data.logradouro,
          PacUF: response.data.uf,
        });
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível consultar o cep, confira seus dados',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoadingCEP(false);
      }
    }
  }, [addToast]);

  const handleSubmitPaciente = useCallback(
    async (dados: IPaciente) => {
      setLoading(true);
      try {
        formRefPaciente.current?.setErrors({});
        const schema = Yup.object().shape({
          PacNome: Yup.string()
            .min(10, 'Mínimo 10 caracteres')
            .required('Nome é obrigatório'),
          PacNomeSocial: Yup.string(),
          pessoaFisicaForm: Yup.string().required('Tipo é obrigatório'),
          PacDataNasc: Yup.date()
            .typeError('Digite uma data válida')
            .when('pessoaFisicaForm', {
              is: '1',
              then: Yup.date()
                .typeError('Digite uma data válida')
                .required('Data de Nascimento é obrigatório'),
            }),
          PacCPF: Yup.string()
            .nullable()
            .transform(x => x || null)
            .min(11, 'Mínimo 11 caracteres'),
          PacRG: Yup.string(),
          PacCNPJ: Yup.string().when('pessoaFisicaForm', {
            is: '0',
            then: Yup.string()
              .min(18, 'Preencha corretamente o CNPJ')
              .required('CNPJ obrigatório'),
          }),
          PacIE: Yup.string(),
          PacContato: Yup.string(),
          PacTelefone: Yup.string()
            .nullable()
            .transform(x => x || null)
            .min(10, 'Mínimo 10 caracteres'),
          PacCelular: Yup.string()
            .min(11, 'Mínimo 11 caracteres')
            .required('Obrigatório'),
          PacEmail: Yup.string(),
          PacEndereco: Yup.string(),
          PacNumero: Yup.string(),
          PacBairro: Yup.string(),
          PacCidade: Yup.string(),
          PacCidadeCodigo: Yup.string(),
          PacCEP: Yup.string()
            .nullable()
            .transform(x => x || null)
            .min(8, 'Mínimo 8 caracteres'),
          PacComplemento: Yup.string(),
          PacUF: Yup.string(),
          PacSexo: Yup.string().when('pessoaFisicaForm', {
            is: '1',
            then: Yup.string().required('Sexo é obrigatório'),
          }),
          PacProfissao: Yup.string(),
          PacEstCivil: Yup.string(),
          PacEscolaridade: Yup.string(),
          PacResponsavel: Yup.string(),
          PacResponsavelCPF: Yup.string()
            .nullable()
            .transform(x => x || null)
            .min(11, 'Mínimo 11 caracteres'),
          PacResponsavelRG: Yup.string(),
          PacTag: Yup.string().required('Origem é obrigatório'),
        });

        const novo = !pacCodigo || pacCodigo === 0;

        const pacienteForm = {
          ...dados,
          ...(novo ? { PacPessoaFisica: dados.pessoaFisicaForm === '1' } : {}),
          ...(dados.pessoaFisicaForm === '1'
            ? {
              PacDataNasc: new Date(
                `${dados.PacDataNasc.toString().replace(/-/g, '/')} 03:00:00`,
              ),
              PacRG: dados.PacRG.toUpperCase(),
              PacResponsavel: dados.PacResponsavel.toUpperCase(),
              PacCPF: replaceCaracteres(dados.PacCPF),
              PacResponsavelCPF: replaceCaracteres(dados.PacResponsavelCPF),
            }
            : { PacContato: dados.PacContato.toUpperCase() }),
          PacNome: dados.PacNome.toUpperCase(),
          PacNomeSocial:
            dados.pessoaFisicaForm === '1'
              ? dados.PacNomeSocial.trim().toUpperCase()
              : '',
          PacEndereco: dados.PacEndereco.toUpperCase(),
          PacNumero: dados.PacNumero.toUpperCase(),
          PacComplemento: dados.PacComplemento.toUpperCase(),
          PacBairro: dados.PacBairro.toUpperCase(),
          PacCidade: dados.PacCidade.toUpperCase(),
          PacEmail: dados.PacEmail.toLowerCase(),
          PacUF: dados.PacUF.toUpperCase(),
          PacTelefone: replaceCaracteres(dados.PacTelefone),
          PacCelular: replaceCaracteres(dados.PacCelular),
          PacCEP: replaceCaracteres(dados.PacCEP),
        };

        await schema.validate(pacienteForm, {
          abortEarly: false,
        });

        if (pacienteForm.PacCPF && !validarCPF(pacienteForm.PacCPF)) {
          formRefPaciente.current?.setFieldError('PacCPF', 'CPF inválido');
          addToast({
            type: 'error',
            title: 'CPF inválido',
          });
          return;
        }

        if (
          !pacienteForm.PacPessoaFisica &&
          pacienteForm.PacCNPJ &&
          !validarCNPJ(pacienteForm.PacCNPJ)
        ) {
          formRefPaciente.current?.setFieldError('PacCNPJ', 'CNPJ inválido');
          addToast({
            type: 'error',
            title: 'CNPJ inválido',
          });
          return;
        }

        if (
          pacienteForm.PacResponsavelCPF &&
          !validarCPF(pacienteForm.PacResponsavelCPF)
        ) {
          formRefPaciente.current?.setFieldError(
            'PacResponsavelCPF',
            'CPF do Responsável inválido',
          );
          addToast({
            type: 'error',
            title: 'CPF do Responsável inválido',
          });
          return;
        }

        if (pacienteForm.PacPessoaFisica || dados.pessoaFisicaForm === '1') {
          const anos = differenceInYears(new Date(), pacienteForm.PacDataNasc);
          if (anos > 110) {
            formRefPaciente.current?.setFieldError(
              'PacDataNasc',
              'Data inválida',
            );
            addToast({
              type: 'error',
              title: 'Data inválida',
              description: 'Data de nascimento não pode ser maior que 110 anos',
            });
            return;
          }
          if (anos < 0 || isAfter(pacienteForm.PacDataNasc, new Date())) {
            formRefPaciente.current?.setFieldError(
              'PacDataNasc',
              'Data inválida',
            );
            addToast({
              type: 'error',
              title: 'Data inválida',
              description:
                'Data de nascimento não pode ser maior que data atual',
            });
            return;
          }

          if (cliSaoPaulo && anos < 18) {
            if (
              !pacienteForm.PacResponsavel ||
              pacienteForm.PacResponsavel.length < 4
            ) {
              formRefPaciente.current?.setFieldError(
                'PacResponsavel',
                'Nome do Responsável obrigatório',
              );
              addToast({
                type: 'error',
                title: 'Nome do Responsável Obrigatório',
              });
              return;
            }
            if (
              !pacienteForm.PacResponsavelCPF ||
              pacienteForm.PacResponsavelCPF.length !== 11
            ) {
              formRefPaciente.current?.setFieldError(
                'PacResponsavelCPF',
                'CPF do Responsável obrigatório',
              );
              addToast({
                type: 'error',
                title: 'CPF do Responsável Obrigatório',
              });
              return;
            }
            // if (
            //   !pacienteForm.PacResponsavelRG ||
            //   pacienteForm.PacResponsavelRG.length < 4
            // ) {
            //   formRefPaciente.current?.setFieldError(
            //     'PacResponsavelRG',
            //     'RG do Responsável obrigatório',
            //   );
            //   addToast({
            //     type: 'error',
            //     title: 'RG do Responsável Obrigatório',
            //   });
            //   return;
            // }
          }

          if (cliSaoPaulo && anos >= 18) {
            if (!pacienteForm.PacCPF || pacienteForm.PacCPF.length !== 11) {
              formRefPaciente.current?.setFieldError(
                'PacCPF',
                'CPF Obrigatório',
              );
              addToast({
                type: 'error',
                title: 'CPF Obrigatório',
              });
              return;
            }
            // if (!pacienteForm.PacRG || pacienteForm.PacRG.length < 4) {
            //   formRefPaciente.current?.setFieldError('PacRG', 'RG Obrigatório');
            //   addToast({
            //     type: 'error',
            //     title: 'RG Obrigatório',
            //   });
            //   return;
            // }
          }
        }

        delete pacienteForm.pessoaFisicaForm;

        if (novo) {
          const response = await api.post<IPaciente>(
            '/pacientes',
            pacienteForm,
          );

          setPaciente(response.data);
          const dataNasc =
            response.data.PacDataNasc &&
              response.data.PacDataNasc.toString().length > 9
              ? parseISO(response.data.PacDataNasc.toString())
              : new Date();
          setIdade(formataIdade(dataNasc, false));

          if (handleRetornaDados) {
            handleRetornaDados({
              ...response.data,
              PacIdade: formataIdade(dataNasc),
              PacDataNasc: dataNasc.toString(),
              PacDataNascFormatada: dataNasc.toString(),
              PacDataCadastro:
                response.data.PacDataCadastro &&
                  response.data.PacDataCadastro.toString().length > 9
                  ? parseISO(response.data.PacDataCadastro.toString())
                  : new Date(),
              PacAtivo: response.data.PacAtivo ? response.data.PacAtivo : false,
              PacRestrito: response.data.PacRestrito
                ? response.data.PacRestrito
                : false,
              avatar_url: response.data.avatar_url
                ? response.data.avatar_url
                : '',
            });
          } else {
            addToast({ title: 'Paciente salvo', type: 'success' });
            window.location.href = `/pacientecadastro/${response.data.PacCodigo}`;
          }
        } else {
          const response = await api.put<IPaciente>(
            `/pacientes/${pacCodigo}`,
            pacienteForm,
          );

          setPaciente(state => {
            return state ? { ...state, ...response.data } : response.data;
          });

          if (handleRetornaDados) {
            const dataNasc =
              response.data.PacDataNasc &&
                response.data.PacDataNasc.toString().length > 9
                ? parseISO(response.data.PacDataNasc.toString())
                : new Date();

            handleRetornaDados({
              ...response.data,
              PacIdade: formataIdade(dataNasc, true),
              PacDataNasc: dataNasc.toString(),
              PacDataNascFormatada: dataNasc.toString(),
              PacDataCadastro:
                response.data.PacDataCadastro &&
                  response.data.PacDataCadastro.toString().length > 9
                  ? parseISO(response.data.PacDataCadastro.toString())
                  : new Date(),
              PacAtivo: response.data.PacAtivo ? response.data.PacAtivo : false,
              PacRestrito: response.data.PacRestrito
                ? response.data.PacRestrito
                : false,
              avatar_url: response.data.avatar_url
                ? response.data.avatar_url
                : '',
            });
          } else {
            addToast({ title: 'Paciente atualizado', type: 'success' });
          }
        }
      } catch (error: any) {
        console.log(error);
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRefPaciente.current?.setErrors(errors);
          return;
        }

        if (error?.response?.data?.message?.includes('CPF já cadastrado')) {
          formRefPaciente.current?.setFieldError('PacCPF', 'CPF já cadastrado');
        }

        if (error?.response?.data?.message?.includes('E-mail já cadastrado')) {
          formRefPaciente.current?.setFieldError(
            'PacEmail',
            'E-mail já cadastrado',
          );
        }

        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Erro ao salvar paciente',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    },
    [addToast, pacCodigo, handleRetornaDados, cliSaoPaulo],
  );

  const handleReturnNewAvatarUrl = useCallback((avatar_url: string) => {
    setPaciente(state => {
      return state && { ...state, avatar_url };
    });
  }, []);

  const handleDeletePaciente = useCallback(async () => {
    setLoading(true);
    setShowModalExcluir(false);
    try {
      await api.delete(`/pacientes/${pacCodigo}`);

      history.replace('/paciente');

      addToast({
        type: 'success',
        title: 'Registro excluído',
      });
    } catch (error) {
      const mensagemErro = getResponseErrors(error);

      addToast({
        type: 'error',
        title: 'Não foi possível excluir o registro',
        description: mensagemErro,
      });
    } finally {
      setLoading(false);
    }
  }, [addToast, pacCodigo, history]);

  const handleVerificaCPF = useCallback(async () => {
    try {
      formRefPaciente.current?.setFieldError('PacCPF', '');
      const cpf = replaceCaracteres(
        formRefPaciente.current?.getFieldValue('PacCPF').toString(),
      );
      if (cpf.length !== 11) return;

      if (!validarCPF(cpf)) {
        formRefPaciente.current?.setFieldError('PacCPF', 'CPF inválido');
        addToast({
          type: 'error',
          title: 'CPF inválido',
        });
        return;
      }
      const chave =
        paciente && paciente.PacChave ? `&chave=${paciente.PacChave}` : '';
      await api.get(`/client/verificacpfcadastrado?cpf=${cpf}${chave}`);
    } catch (error) {
      const mensagemErroApi = getResponseErrors(error);
      if (mensagemErroApi === 'CPF já cadastrado')
        formRefPaciente.current?.setFieldError('PacCPF', 'CPF já Cadastrado');
      addToast({
        title: 'CPF inválido',
        type: 'error',
        description: mensagemErroApi,
      });
    }
  }, [addToast, paciente]);

  const handleVerificaEmail = useCallback(async () => {
    try {
      formRefPaciente.current?.setFieldError('PacEmail', '');
      const email = formRefPaciente.current
        ?.getFieldValue('PacEmail')
        .toString();

      if (email.length === 0) return;

      const chave =
        paciente && paciente.PacChave ? `&chave=${paciente.PacChave}` : '';
      await api.get(`/client/verificaemailcadastrado?email=${email}${chave}`);
    } catch (error) {
      const mensagemErroApi = getResponseErrors(error);
      if (mensagemErroApi === 'E-mail já cadastrado')
        formRefPaciente.current?.setFieldError(
          'PacEmail',
          'E-mail já Cadastrado',
        );
      addToast({
        title: 'E-mail inválido',
        type: 'error',
        description: mensagemErroApi,
      });
    }
  }, [addToast, paciente]);

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleOnChangeVazio = useCallback(() => { }, []);

  const handleEnviarWhatsapp = useCallback(async () => {
    try {
      if (paciente && paciente.PacCodigo) {
        setLoading(true);
        const dadosMensagem = {
          message:
            paciente.textoDigisacFormatado && paciente.textoDigisacFormatado !== ''
              ? paciente.textoDigisacFormatado
              : paciente.textoMensagem,
          type: 'Envio acesso whatsapp',
          numeroTo: `55${paciente.PacCelular}`,
        };
        await api.put(
          `/whatsapp/sendmessage/${paciente.PacCodigo}`,
          dadosMensagem,
        );

        addToast({
          title: 'Envio de Acesso',
          type: 'success',
          description: 'Dados enviados com sucesso.',
        });
      }
    } catch (error) {
      const mensagemErroApi = getResponseErrors(error);

      addToast({
        title: 'Envio de Acesso',
        type: 'error',
        description: mensagemErroApi,
      });
    } finally {
      setLoading(false);
    }
  }, [addToast, paciente]);

  const handleEnviarEmail = useCallback(async () => {
    try {
      if (paciente && paciente.PacCodigo) {
        if (paciente.PacEmail === '') {
          addToast({
            title: 'Envio de Acesso',
            type: 'error',
            description: 'Email não cadastrado.',
          });
          return;
        }
        setLoading(true);
        const dadosMensagem = {
          PacNome:
            paciente.PacNomeSocial.trim() !== ''
              ? paciente.PacNomeSocial
              : paciente.PacNome,
          PacEmail: paciente.PacEmail,
          textoMensagem: paciente.textoMensagem,
        };
        await api.put(
          `/pacientes/enviaEmailDadosAcesso/${paciente.PacCodigo}`,
          dadosMensagem,
        );

        addToast({
          title: 'Envio de Acesso',
          type: 'success',
          description: 'Dados enviados com sucesso.',
        });
      }
    } catch (error) {
      const mensagemErroApi = getResponseErrors(error);

      addToast({
        title: 'Envio de Acesso',
        type: 'error',
        description: mensagemErroApi,
      });
    } finally {
      setLoading(false);
    }
  }, [addToast, paciente]);

  return (
    <>
      {loading && <Loading />}

      {showModalDadosAcesso && (
        <Modal
          handleFecharModal={() => setShowModalDadosAcesso(false)}
          show={showModalDadosAcesso}
          titulo="Enviar dados de Acesso"
          large
        >
          <span
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: htmlDecode(paciente?.textoMensagem || ''),
            }}
          />
          <div className="d-flex justify-content-between mt-2">
            <Button
              type="button"
              variant="secondary"
              size="sm"
              onClick={handleEnviarWhatsapp}
              disabled={loading}
            >
              Enviar WhatsApp
            </Button>

            <CopyToClipboard
              text={replaceHTMLparaWhatsapp(paciente?.textoMensagem || '')}
            >
              <Button type="button" variant="info" size="sm" disabled={loading}>
                Copiar mensagem
              </Button>
            </CopyToClipboard>

            <Button
              type="button"
              variant="primary"
              onClick={handleEnviarEmail}
              size="sm"
              disabled={loading}
            >
              Enviar E-mail
            </Button>
          </div>
        </Modal>
      )}

      {showModalExcluir && (
        <Modal
          handleFecharModal={() => setShowModalExcluir(false)}
          show={showModalExcluir}
          titulo="Excluir registro"
          large={false}
        >
          <p className="my-3">
            Essa operação não pode ser desfeita, deseja realmente prosseguir?
          </p>
          <div className="d-flex justify-content-between mt-2">
            <Button
              type="button"
              variant="danger"
              onClick={handleDeletePaciente}
              size="sm"
            >
              <FaTrashAlt /> Sim, excluir
            </Button>

            <Button
              type="submit"
              variant="secondary"
              size="sm"
              onClick={() => setShowModalExcluir(false)}
            >
              Não, voltar
            </Button>
          </div>
        </Modal>
      )}
      <Row noGutters>
        <Col md={12}>
          <ContainerDados className="rounded">
            <Form
              ref={formRefPaciente}
              // initialData={}
              onSubmit={handleSubmitPaciente}
            >
              <Input
                type="hidden"
                name="pessoaFisicaForm"
                value={pessoaFisica ? '1' : '0'}
              />
              <Row>
                {paciente ? (
                  <Col md={4} lg={3}>
                    <Avatar
                      codigo={paciente.PacCodigo}
                      nome={paciente.PacNome}
                      avatar_url={paciente.avatar_url}
                      path="pacientes"
                      handleReturnNewAvatarUrl={handleReturnNewAvatarUrl}
                    />
                  </Col>
                ) : (
                  <Col md={4} lg={3}>
                    <div className="d-flex justify-content-center align-items-center h-100">
                      <ButtonGroup size="sm" style={{ display: 'inline' }}>
                        <Button
                          type="button"
                          size="sm"
                          variant={
                            pessoaFisica ? 'success' : 'outline-secondary'
                          }
                          onClick={() => setPessoaFisica(true)}
                        >
                          Pessoa Física
                        </Button>
                        <Button
                          type="button"
                          size="sm"
                          variant={
                            pessoaFisica ? 'outline-secondary' : 'success'
                          }
                          onClick={() => setPessoaFisica(false)}
                        >
                          Pessoa Jurídica
                        </Button>
                      </ButtonGroup>
                    </div>
                  </Col>
                )}
                <Col>
                  <Row>
                    <Col
                      md={!pessoaFisica ? 6 : 12}
                      xl={!pessoaFisica ? 6 : 12}
                    >
                      <Input
                        name="PacNome"
                        label={pessoaFisica ? 'Nome' : 'Razão Social'}
                        maxLength={255}
                        disabled={
                          !!paciente?.cartao &&
                          paciente.cartao.length > 0 &&
                          user.UsuTipo !== TIPO_USUARIO.ADMINISTRADOR
                        }
                      />
                    </Col>
                    {pessoaFisica && (
                      <>
                        <Col md={6} xl={6} className="mt-2">
                          <Input
                            name="PacNomeSocial"
                            label="Nome Social"
                            maxLength={100}
                          // disabled={
                          //   !!paciente?.cartao &&
                          //   paciente.cartao.length > 0 &&
                          //   user.UsuTipo !== TIPO_USUARIO.ADMINISTRADOR
                          // }
                          />
                        </Col>
                      </>
                    )}
                    <Col md={6} xl={6} className={pessoaFisica ? 'mt-2' : ''}>
                      <Input
                        name="PacEmail"
                        label="Email"
                        type="email"
                        maxLength={100}
                        onBlur={handleVerificaEmail}
                      />
                    </Col>
                    <div className="w-100 mt-2" />
                    {pessoaFisica ? (
                      <>
                        <Col md={4}>
                          <InputMask
                            name="PacCPF"
                            label="CPF"
                            mask="999.999.999-99"
                            placeholder="000.000.000-00"
                            minLength={15}
                            onBlur={handleVerificaCPF}
                          />
                        </Col>
                        <Col md={4}>
                          <Input name="PacRG" maxLength={18} label="RG" />
                        </Col>
                        <Col md={4}>
                          <SelectSync
                            name="PacEstCivil"
                            label="Estado Civil"
                            placeholder="Selecione"
                            handleSelectChange={handleOnChangeVazio}
                            options={optionsEstCivil}
                          />
                        </Col>
                      </>
                    ) : (
                      <>
                        <Col md={4}>
                          <InputMask
                            name="PacCNPJ"
                            label="CNPJ"
                            mask="99.999.999/9999-99"
                            alwaysShowMask={false}
                            placeholder="00.000.000/0000-00"
                          />
                        </Col>
                        <Col md={4}>
                          <Input
                            name="PacIE"
                            maxLength={18}
                            label="Insc.Estadual"
                          />
                        </Col>
                        <Col md={4}>
                          <Input
                            name="PacContato"
                            label="Contato"
                            placeholder="Contato na empresa"
                          />
                        </Col>
                      </>
                    )}
                  </Row>
                </Col>
              </Row>

              <Row className="my-2">
                {pessoaFisica && (
                  <Col md={3}>
                    {idade && (
                      <b style={{ float: 'right' }}>{`idade: ${idade}`}</b>
                    )}
                    <Input
                      name="PacDataNasc"
                      type="date"
                      label="Data de Nascimento"
                      max={limitDate && limitDate.max}
                      min={limitDate && limitDate.min}
                    />
                  </Col>
                )}
                <Col md={3}>
                  <InputMask
                    name="PacCelular"
                    label="Celular"
                    mask="(99) 99999-9999"
                    alwaysShowMask={false}
                    placeholder="(00) 00000-0000"
                  />
                </Col>
                <Col md={3}>
                  <InputMask
                    name="PacTelefone"
                    label="Telefone"
                    mask="(99) 99999-9999"
                    placeholder="(00) 00000-0000"
                  />
                </Col>
                <Col md={3}>
                  <SelectSync
                    name="PacTag"
                    label="Origem"
                    placeholder="Selecione"
                    handleSelectChange={handleOnChangeVazio}
                    options={optionsOrigemCadastro}
                    isDisabled={((pacCodigo !== undefined && pacCodigo > 0 && user.UsuCodigo !== 1)) || (!cliSaoPaulo && user.UsuCodigo !== 1)}
                  />
                </Col>
              </Row>

              {pessoaFisica && (
                <Row>
                  <Col md={4}>
                    <SelectSync
                      name="PacSexo"
                      label="Sexo"
                      placeholder="Selecione"
                      handleSelectChange={handleOnChangeVazio}
                      options={optionsSexo}
                    />
                  </Col>
                  <Col md={4}>
                    <SelectSync
                      name="PacEscolaridade"
                      label="Escolaridade"
                      placeholder="Selecione"
                      handleSelectChange={handleOnChangeVazio}
                      options={optionsEscolaridade}
                    />
                  </Col>
                  <Col md={4}>
                    <Input
                      name="PacProfissao"
                      maxLength={50}
                      label="Profissão"
                    />
                  </Col>

                </Row>
              )}

              {pessoaFisica && (
                <>
                  <h4 className="text-muted border-bottom mt-2">Responsável</h4>
                  <Row>
                    <Col md={4}>
                      <Input
                        name="PacResponsavel"
                        maxLength={100}
                        label="Responsável"
                      />
                    </Col>
                    <Col md={4}>
                      <InputMask
                        name="PacResponsavelCPF"
                        label="CPF do Responsável"
                        mask="999.999.999-99"
                        placeholder="000.000.000-00"
                      />
                    </Col>
                    <Col md={4}>
                      <Input
                        name="PacResponsavelRG"
                        maxLength={15}
                        label="RG do Responsável"
                      />
                    </Col>
                  </Row>
                </>
              )}
              <h4 className="text-muted border-bottom mt-2">Endereço</h4>
              <Row>
                <Col md={3} lg={2}>
                  {/* <Input
                    name="PacCEP"
                    label="CEP"
                    type="tel"
                    maxLength={9}
                    onBlur={handleBuscaCepApi}
                  /> */}
                  <InputMask
                    name="PacCEP"
                    label="CEP"
                    mask="99999-999"
                    placeholder="00000-000"
                    onBlur={handleBuscaCepApi}
                  />
                </Col>
                <Col md={4}>
                  <br />
                  <Button
                    size="sm"
                    className="mt-1"
                    onClick={handleBuscaCepApi}
                  >
                    {loadingCEP ? 'buscando...' : 'Buscar Endereço'}
                  </Button>
                </Col>
                <div className="w-100 mt-2" />
                <Col md={7}>
                  <Input name="PacEndereco" maxLength={200} label="Endereço" />
                </Col>
                <Col md={2}>
                  <Input name="PacNumero" maxLength={10} label="Numero" />
                </Col>
                <Col md={3}>
                  <Input
                    name="PacComplemento"
                    maxLength={30}
                    label="Complemento"
                  />
                </Col>
              </Row>

              <Row className="mt-2">
                <Col md={4}>
                  <Input name="PacBairro" maxLength={30} label="Bairro" />
                </Col>
                <Col md={3}>
                  <Input name="PacCidade" maxLength={30} label="Cidade" />
                </Col>
                <Col md={2}>
                  <Input
                    name="PacCidadeCodigo"
                    maxLength={30}
                    disabled
                    label="Cidade Codigo"
                  />
                </Col>
                <Col md={3}>
                  <SelectSync
                    name="PacUF"
                    label="UF"
                    placeholder="Selecione"
                    handleSelectChange={handleOnChangeVazio}
                    options={optionsUF}
                  />
                </Col>
              </Row>

              <div className="d-flex justify-content-around mt-2">
                <Button type="submit" variant="success">
                  Salvar dados
                </Button>

                {paciente?.textoMensagem !== '' && pacCodigo !== undefined && pacCodigo > 0 && (
                  <Button
                    type="button"
                    variant="secondary"
                    className="px-md-5"
                    onClick={() => setShowModalDadosAcesso(true)}
                  >
                    Enviar acesso
                  </Button>
                )}
                {paciente && (
                  <Button
                    type="button"
                    variant="outline-danger"
                    onClick={() => setShowModalExcluir(true)}
                  >
                    <FaTrashAlt /> Excluir
                  </Button>
                )}
              </div>
            </Form>
          </ContainerDados>
        </Col>
      </Row>
    </>
  );
};

export default PacienteCadastro;
